import EmitterManager from '../managers/EmitterManager';
import { SCROLL, RESIZE } from 'core/Events';

class AbstractComponent {
  constructor(options) {
    this.$element = options.$element;
    delete options.$element;

    this.options = options;
    this.ui = this.getUI();
    this.bind();
    this.initializeBeforeEvents();
    this.events(true);
    this.initialize();
  }

  initializeBeforeEvents() {}

  initialize() {}

  getUI() {
    if (!this.$element) return {};
    const ui = {};
    ui.$element = this.$element;
    return ui;
  }

  bind() {
    const fns = ['handleResize', 'handleScroll'];
    fns.forEach((fn) => {
      if (this[fn] instanceof Function) {
        this[fn] = this[fn].bind(this);
      }
    });
  }

  events(listen = false) {
    const method = listen ? 'on' : 'removeListener';
    if (this.handleResize instanceof Function) {
      EmitterManager[method](RESIZE, this.handleResize);
    }

    if (this.handleScroll instanceof Function) {
      EmitterManager[method](SCROLL, this.handleScroll);
    }
  }
}

export default AbstractComponent;
